import { render, staticRenderFns } from "./ServiceDown.vue?vue&type=template&id=e5cb8912&scoped=true&"
import script from "./ServiceDown.vue?vue&type=script&lang=js&"
export * from "./ServiceDown.vue?vue&type=script&lang=js&"
import style0 from "./ServiceDown.vue?vue&type=style&index=0&id=e5cb8912&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5cb8912",
  null
  
)

export default component.exports